import {getTcf2FromGlobalStorage, setTcf2ToGlobalStorage} from './globalCookie';
import {setCookie, existsCookie, deleteCookie} from './cookie';
import {logger} from './logger';
import {CONSENT_COOKIE_V2_NAME} from '../constants';

/**
 * Sets TCF2.0 cookie.
 * @param {string} consent
 */
const setConsentCookieV2 = consent => setCookie(consent, CONSENT_COOKIE_V2_NAME);

/**
 * Check if TCF2.0 cookie exists.
 * @return {boolean}
 */
const existsConsentCookieV2 = () => existsCookie(CONSENT_COOKIE_V2_NAME);

/**
 * Delete TCF2.0 cookie.
 * @return {boolean}
 */
const deleteConsentCookieV2 = () => deleteCookie(CONSENT_COOKIE_V2_NAME);

/**
 * Returns true if "euconsent.v2" already exists in Profile.
 * @param {Object} data
 * @return {boolean}
 */
export const hasEuconsentV2 = data => data && data.euconsent && data.euconsent.v2 && data.euconsent.v2.encodedCookie;

/**
 * Tries to copy TCF2.0 string from global
 * @param {string} userType
 * @returns {boolean} true if successfully copy, false if cookie not found
 */
export const copyTcf2FromGlobalStorage = async userType => {
  try {
    const globalCookie = await getTcf2FromGlobalStorage(userType);

    if (existsConsentCookieV2()) {
      deleteConsentCookieV2();
    }
    setConsentCookieV2(globalCookie);
    logger(2101, 'TCF2.0 successfully copied from global storage, CMP1 is done.');
    return true;
  } catch (e) {
    logger(2102, 'TCF2.0 not found in global storage, continue as usual.');
    return false;
  }
};

export const saveTcf2ToBrowser = cookie => {
  if (existsConsentCookieV2()) {
    deleteConsentCookieV2();
  }
  setConsentCookieV2(cookie);
};

export const signedUserHasTcf2ConsentCookie = async (profileData, userType) => {
  if (existsConsentCookieV2()) {
    deleteConsentCookieV2();
  }
  setConsentCookieV2(profileData.euconsent.v2.encodedCookie);
  logger(2103, 'TCF2.0 set into local domain.');
  await setTcf2ToGlobalStorage(profileData.euconsent.v2.encodedCookie, userType);
  logger(2103, 'TCF2.0 set into global storage.');
};
